import { client } from "./api";
import { SET_CHALLENGE_MODAL_DATA } from "../store/user/actions";

export const watchChallengeModal = store => {
  client.interceptors.response.use(
    response => {
      if (response.data && response.data.taskModalData) {
        store.dispatch({ type: SET_CHALLENGE_MODAL_DATA, payload: response.data.taskModalData });
      }
      return response;
    },
    error => {
      return Promise.reject(error.message);
    },
  );
};
